<template>
  <div class="gridClass mb-6">
    <div
      class="gridClass flex justify-between flex-col-reverse laptop:flex-row"
    >
      <div class="laptop:w-[50%] pb-5 flex flex-col laptop:pe-10">
        <div class="font-bold">
          <h1
            class="text-2xl laptop:text-5xl text-center text-blue-500 mb-14 mt-6"
          >
            نواتل نسل نوین ارتباط
          </h1>
          <h3 class="text-base laptop:text-xl mb-0 laptop:mb-14 text-justify">
            نواتل تنها سرویس ارتباطات یکپارچه ابری با اپلیکیشن اختصاصی و بدون
            محدودیت در ایران است که به کمک آن می‌توانید تمام مکالمات را مدیریت و
            با همکاران و مشتریان با ساده ترین و قدرتمندترین ابزار تعامل کنید.
          </h3>
        </div>
        <div
          class="flex justify-between mt-10 flex-col laptop:flex-row [&>*]:laptop:w-[45%] [&>*]:mb-4 [&>*]:laptop:mb-0"
        >
          <BaseButton
            size="full"
            @click="showMainModal"
            text="دمو و مشاوره رایگان"
          />
            <BaseButtonLink
              isShadow
              size="full"
              text="مشاهده قیمت‌ها"
              styleType="secondary"
              id="show_price"
              to="/prices/"
            />
        </div>
      </div>
      <div class="laptop:w-[50%] mt-0 laptop:-mt-3">
        <NuxtImg
          sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
          width="1000"
          height="1000"
          quality="100"
          format="webp"
          class="w-full laptop:w-[90%] mx-auto mt-6 rounded-xl"
          src="img/main-page.webp"
          alt="ﻧﻮاﺗﻞ، نسل نوین ارتباط"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const isMainModalShowState = useState('isMainModalShow')

const showMainModal = () => {
  isMainModalShowState.value = true
}
</script>
